import React from "react";

export const Careers = () => {
  return <div className="under">Under Development</div>;
};
